export const onlyLettersNumbersAndAccents = (value: string): string => {
	if (!value) return value

	return value.replace(/[^\w\s\u00C0-\u017F]/gi, "")
}
